import React from 'react';
import { makeStyles } from 'pencil/styles';

const useStyles = makeStyles((theme) => ({
  error: {
    marginTop: 5,
  },
}));
const mapFieldToInput = (Component) => ({
  input,
  meta,
  label,
  change,
  propertyName,
  initialValue,
  ...props
}) => {
  const fieldProps = {
    disabled: props.disabled || meta.submitting,
  };
  if (label) {
    fieldProps.label = label;
  }
  const inputsValue = input;
  inputsValue.value = inputsValue.value.toUpperCase();
  const classes = useStyles();

  return (
    <Component
      {...inputsValue}
      {...fieldProps}
      FormHelperTextProps={{ classes: { root: classes.error } }} // <- smth like that
      error={meta.touched && typeof meta.error !== 'undefined'}
      helperText={meta.touched && meta.error ? meta.error : null}
      change={change}
      propertyName={propertyName}
      input={input}
      meta={meta}
      initialValue={initialValue}
    />
  );
};

export default mapFieldToInput;
